import { post } from '../../../../shared/js/json-fetch'
import Dialog from '../shared/Dialog'
import ToggablePassword from '../shared/ToggablePassword'
import { Turnstile } from '@marsidev/react-turnstile'
import React, { useRef, useState } from 'react'
import { useFormStatus } from 'react-dom'
import type { FlashProps } from '../../shared/Module'
import type { TurnstileInstance } from '@marsidev/react-turnstile'

type SignupFormProps = {
  registrationUrl?: string
  setCustomer: Function
  turnstileSiteKey?: string
}

// TODO: affichage de validation de connexion
export default function SignupForm({
  registrationUrl,
  setCustomer,
  turnstileSiteKey,
}: SignupFormProps) {
  const turnstileRef = useRef<TurnstileInstance | null>(null)
  const { pending } = useFormStatus()
  const [flash, setFlash] = useState<FlashProps | null>(null)
  const [passwordVisible, setPasswordVisible] = useState(false)
  const messages = Array.isArray(flash?.message)
    ? flash.message
    : flash && [flash.message]

  return (
    <div className='c-signup--account'>
      {flash && messages && (
        <div className='o-container-3'>
          <div className={`u-mb-2 c-message c-message--${flash.kind}`}>
            <ul>
              {messages.map((msg) => (
                <li>{msg}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      <form
        action={handleRegistration}
        id='customer-sign-up'
        // honeypot
      >
        <p>Pas de compte ? Créer un compte :</p>
        <p className='field'>
          <input
            name='first_name'
            id='first_name'
            type='text'
            autoComplete='given-name'
            placeholder=' '
            required
            aria-required
          />
          <label htmlFor='email'>Prénom</label>
        </p>
        <p className='field'>
          <input
            name='last_name'
            id='last_name'
            type='text'
            autoComplete='family-name'
            placeholder=' '
            required
            aria-required
          />
          <label htmlFor='email'>Nom</label>
        </p>
        <p className='field'>
          <input
            name='email'
            id='email'
            type='text'
            autoComplete='email'
            placeholder=' '
            required
            aria-required
          />
          <label htmlFor='email'>E-mail</label>
        </p>
        <ToggablePassword
          id='signup-pass'
          name='password'
          label='Mot de passe'
          containerClassName='field'
        />
        <p className='field'>
          <input
            name='birthday'
            id='birthday'
            type='date'
            autoComplete='bday'
            placeholder=' '
          />
          <label htmlFor='birthday'>Votre date de naissance</label>
        </p>
        <button
          className='mlc-btn mlc-btn-type-3'
          type='submit'
          disabled={pending}
        >
          {pending ? 'Création en cours…' : 'Je crée mon compte'}
        </button>
        {turnstileSiteKey && (
          <Turnstile ref={turnstileRef} siteKey={turnstileSiteKey} />
        )}
      </form>
    </div>
  )

  async function handleRegistration(formData: any) {
    if (!registrationUrl) return

    const email = formData.get('email')
    const password = formData.get('password')
    const first_name = formData.get('first_name')
    const last_name = formData.get('last_name')
    const turnstileToken = turnstileRef.current?.getResponse()

    const { customer, flash } = await post(registrationUrl, {
      cf_turnstile_response: turnstileToken,
      customer: {
        email,
        password,
        first_name,
        last_name,
      },
    })

    setFlash(flash)

    customer && setCustomer(customer)
  }

  function togglePasswordVisibility() {
    setPasswordVisible(!passwordVisible)
  }
}
